export default __webpack_public_path__ + "img/mixed-fleet-control.72b8a8c2.jpg";